import React, { ReactNode } from 'react';
import { Dropdown, FilterPill } from '../providers/harmony-scope/lazy-enablers';

interface IProps {
  label: string;
  values: string[];
  children: ReactNode;
}

const DropdownFilterPill = (props: IProps) => {
  const { label, values, children } = props;
  return (
    <Dropdown>
      <FilterPill slot="trigger" caret values={values}>
        {label}
      </FilterPill>
      {children}
    </Dropdown>
  );
};

export default DropdownFilterPill;
